import { FunctionComponent } from 'react';
import { IconButton } from 'omakase';

export interface Props {
  disabled?: boolean;
  onClick(): void;
  title: string;
  dataTestId?: string;
}

const ControlButton: FunctionComponent<Props> = ({
  disabled,
  onClick,
  title,
  children,
  dataTestId,
}) => {
  return (
    <IconButton
      disabled={disabled}
      variant="basicBorderless"
      size="medium"
      onClick={onClick}
      className="TravelLogMap-controlButton"
      data-testid={dataTestId}
      aria-label={title}
    >
      {children}
    </IconButton>
  );
};

export default ControlButton;
